import {
  AdminSpinner,
  ListSpinner,
  QueryStatus,
  restaurantImage,
} from '@vgrubs/components';
import { NoDataComponent } from 'components/src/adminComponents/NoDataComponent/NoDataComponent';
import { useVerificationsRestaurantsInfiniteScroll } from '../hooks/useVerificationsRestaurantsInfiniteScroll';
import { RestaurantComponent } from '../components/RestaurantComponent';

export const RestaurantsSection = ({ query }: { query: string }) => {
  const { locations, observerRef, isFetchingNextPage, status } =
    useVerificationsRestaurantsInfiniteScroll(query);

  return (
    <>
      {locations.map((location) => (
        <RestaurantComponent key={location.id} location={location} />
      ))}

      {locations.length === 0 &&
        status !== QueryStatus.PENDING &&
        !isFetchingNextPage && (
          <NoDataComponent
            image={restaurantImage}
            title="No Restaurants!"
            description={
              query
                ? `No restaurants to verify match "${query}".`
                : 'You currently do not have any restaurants to verify.'
            }
            height="70vh"
            heightSM="70vh"
          />
        )}

      <ListSpinner loading={isFetchingNextPage} observerRef={observerRef} />
      {status === QueryStatus.PENDING && <AdminSpinner />}
    </>
  );
};
